<template>
  <div class="search">
    <i v-show="!hasFilter" class="material-icons">search</i>
    <i v-show="hasFilter" class="material-icons clickable" @click="clearSearch()" title="clear fiters">clear</i>
    <input type="text" v-model="search" ref="search">
    <i class="material-icons add-search" @click.stop="addSearch(exportable)" v-show="canAddSearch">star_border</i>
    <i class="material-icons remove-search" @click.stop="deleteSearch(exportable)" v-show="!canAddSearch">star</i>
  </div>
</template>

<script>
  import _ from 'underscore'
  import { mapGetters } from 'vuex'
  import FiltersCollection from '@/domain/FiltersCollection'

  export default {
    name: 'search',
    props: [],
    data () {
      return {}
    },
    computed: {
      ...mapGetters({
        exportable: 'destiny/filters/toExportable'
      }),
      search: {
        get () {
          return this.$store.state.destiny.filters.search
        },
        set (search) {
          this.updateSearch(this.$store, search)
        }
      },
      searches () {
        return this.$store.state.destiny.filters.searches
      },
      canAddSearch () {
        return this.searches.indexOf(this.exportable) === -1
      },
      hasFilter () {
        const fc = new FiltersCollection(this.$store.state.destiny.filters)
        return Object.values(fc.cleanFilters).length
      }
    },
    methods: {
      clearSearch () {
        this.$store.commit('destiny/filters/applyFilters', {filters: {}})
      },
      updateSearch: _.debounce((store, search) => {
        store.commit('destiny/filters/updateSearch', {search})
      }, 200),
      deleteSearch (toDelete) {
        this.$store.commit('destiny/filters/updateSearches', {
          searches: this.searches.filter(needle => needle !== toDelete)
        })
      },
      addSearch (toAdd) {
        this.$store.commit('destiny/filters/updateSearches', {
          searches: this.searches.concat([toAdd])
        })
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  .search {
    display: flex;

    i.material-icons {
      font-size: 2rem;
      padding: 0.7rem 0.5rem;
    }
    input {
      width: 100%;
      -webkit-appearance: none;
      background-color: rgba(0, 0, 0, 1);
      border: 0;
      font-size: 2rem;

      display: block;
      border: none;
      padding: .5rem 0;
      border-bottom: solid 1px $search-color;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 99%, $search-color 1%);

      background-repeat: no-repeat;
      color: darken($search-color, 20%);
      &:focus {
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, $search-color 4%);
      }

      &:focus, &:valid {
        box-shadow: none;
        outline: none;
        background-position: 0 0;
      }
    }
    .add-search {
      cursor: pointer;
      color: rgba(255, 255, 255, .6);
      transition: color 0.2s ease-in-out;
      &:hover {
        color: rgba(255, 255, 255, .9);

      }
    }
  }
</style>



// WEBPACK FOOTER //
// Search.vue?0abf1e11